import { atom } from 'recoil';
import { v1 } from 'uuid';

import { safeLocalStorage } from '@utils/storage';

import { RoleTypes } from '@src/types/role';

const localStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: any) => {
    const savedValue = safeLocalStorage?.get(key);

    if (savedValue !== null) {
      savedValue && setSelf(JSON.parse(savedValue));
    }

    onSet((newValue: any, _: any, isReset: boolean) => {
      isReset
        ? safeLocalStorage?.remove(key)
        : safeLocalStorage?.set(key, JSON.stringify(newValue));
    });
  };

export interface AuthProps {
  isLogin: boolean;
  name: string;
  email: string;
  company: string;
  role: RoleTypes;
  companyId: string | undefined;
}

export const auth = atom<AuthProps>({
  key: `auth/${v1()}`,
  default: {
    isLogin: false,
    name: '',
    email: '',
    role: undefined,
    company: '',
    companyId: undefined,
  } as AuthProps,
  effects: [localStorageEffect('authentication')],
});

/** 자료제출 로그인정보 */
interface SubmitAuthProps {
  isLogin: boolean;
}

export const submitAuth = atom<SubmitAuthProps>({
  key: `submitAuth/${v1()}`,
  default: {
    isLogin: false,
  } as SubmitAuthProps,
  effects: [localStorageEffect('submitAuthentication')],
});
